import React from 'react';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import './Services.scss';
import flagAr from '../../assets/courses/argentina-flag.png';
import worldFlag from '../../assets/courses/ww-flag.png';


const Services = () => {
    return (
        <section className='service-section pt-100 ' data-aos="fade-up" data-aos-duration="1000">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-sm-12">
                        <SectionTitle title="" subTitle="Más reciente"/>
                        <div className="blog-card h-20 d-flex flex-column">
                    <div className="blog-text">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5 className="fw-bold mb-0">CABA - Argentina</h5>
                    <img src={flagAr} alt="Argentina Flag" style={{ width: '64px' }} className='rounded' />
                  </div>
                  <p className="fw-semibold mb-2">7, 8 y 9 de Agosto 2025</p>

                  <span className="badge bg-danger text-white mb-2" style={{ fontSize: '0.75rem' }}>
                    Presencial
                  </span>
                  <p style={{ whiteSpace: 'pre-line' }}>Odontología Restauradora desde el Diagnóstico, curso sobre anteriores directos.
                  </p>
                </div>
                <div className='theme-btn'>
                   <a
                    className=" mt-3"
                    href="https://wa.me/5491126412362?text=Info%20sobre%20curso%20de%20la%20Dra%20Fioreella"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Más Información
                  </a> 
                </div>
              </div>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <p className='service-title-text'>Transforma tu práctica odontológica con un enfoque integral en estética dental. Este curso te guiará paso a paso desde el diagnóstico hasta la restauración, enseñándote técnicas avanzadas para ofrecer resultados naturales y duraderos.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Services;